import { isType } from 'variant';
import { CliSystemErrorCode } from './cli-error-codes.js';
import type { CliError } from './cli-error.js';
import { isCliSystemError } from './is-cli-error.js';

export function getUnknownFailureMessage(error: CliError): string {
  if (
    isCliSystemError(error) &&
    isType(error.cliCode, CliSystemErrorCode.UnknownFailure) &&
    error.cliCode.error instanceof Error &&
    typeof error.cliCode.error.message === 'string'
  ) {
    return error.cliCode.error.message;
  }
  return error.message;
}
